<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Admin Management <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewUser()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add New</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar placeholder="From: dd / mm / yy"  appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							[showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadUsers($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button class="clearFilterBtn" (click)="clear()">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="p1-table-columns hide-columns" [scrollable]="true" scrollHeight="auto"
						scrollDirection="both" #dt [value]="userlist" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" paginatorPosition="bottom"
						styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="firstName" class="firstNameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Name
										<p-sortIcon field="firstName"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="email" class="emailTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Email Id
										<p-sortIcon field="email"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="cityname" class="cityNameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										City
										<p-sortIcon field="cityname"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="statename" class="stateNameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										State
										<p-sortIcon field="statename"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="countryname" class="countryNameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Country
										<p-sortIcon field="countryname"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="zipcode" class="zipcodeTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Zipcode
										<p-sortIcon field="zipcode"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="dob" class="dobTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										DOB
										<p-sortIcon field="dob"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="rolename" class="genderTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Role name
										<p-sortIcon field="rolename"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="gender" class="genderTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Gender
										<p-sortIcon field="gender"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="createdDateTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by" class="createdByTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="updatedDateTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" class="modifiedByTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th class="actionTd p-frozen-column">
									 
										Action 
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="fullName" class="firstNameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'fullName', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['fullName'] ? dt.filters['fullName'].value : ''"  [(ngModel)]="fullName"/>
								</th>
								<th [ngSwitch]="email" class="emailTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'email', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['email'] ? dt.filters['email'].value : ''" [(ngModel)]="email" />
								</th>
								<th [ngSwitch]="cityname" class="cityNameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'cityname', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['cityname'] ? dt.filters['cityname'].value : ''" [(ngModel)]="cityname" />
								</th>
								<th [ngSwitch]="statename" class="stateNameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'statename', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['statename'] ? dt.filters['statename'].value : ''" [(ngModel)]="statename"/>
								</th>
								<th [ngSwitch]="countryname" class="countryNameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'countryname', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['countryname'] ? dt.filters['countryname'].value : ''" [(ngModel)]="countryname"/>
								</th>
								<th [ngSwitch]="zipcode" class="zipcodeTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'zipcode', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['zipcode'] ? dt.filters['zipcode'].value : ''" [(ngModel)]="zipcode"/>
								</th>
								<th [ngSwitch]="dob" class="dobTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'dob', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="dcalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="rolename" class="zipcodeTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									<p-dropdown appendTo="body" #pDropDownId1 [options]="roles" 
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'rolename', 'equals')"
										styleClass="p-column-filter" placeholder="Select Role" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="gender" class="genderTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									<p-dropdown appendTo="body" #pDropDownId1 [options]="genders" [(ngModel)]="gender"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'gender', 'equals')" styleClass="p-column-filter"
										placeholder="Select Gender" [showClear]="true">
								
										<ng-template let-option pTemplate="item">
											<span [class]="'customer-badge status-' + option.value">
												{{option.label}}
											</span>
										</ng-template>
								
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at" class="createdDateTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby" class="createdByTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" [(ngModel)]="createdby"/>
								</th>
								<th [ngSwitch]="updated_at" class="updatedDateTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby" class="modifiedByTd"
									[ngClass]="hide ? 'hide-column ' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" [(ngModel)]="updatedby" />
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown appendTo="body" #pDropDownId2 [options]="statuses" 
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th class="actionTd p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-user>
							<tr class="p-selectable-row">
								<td class="firstNameTd">
									{{user.fullName}}
								</td>
								<td class="emailTd">
									{{user.email}}
								</td>
								<td class="cityNameTd">
									{{user.cityname}}
								</td>
								<td class="stateNameTd">
									{{user.statename}}
								</td>
								<td class="countryNameTd">
									{{user.countryname}}
								</td>
								<td class="zipcodeTd">
									{{user.zipcode}}
								</td>
								<td class="dobTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.dob}}
								</td>
								<td class="zipcodeTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.rolename}}
								</td>
								<td class="genderTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.gender}}
								</td>
								<td class="createdDateTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="createdByTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.createdBy}}
								</td>
								<td class="updatedDateTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.updated_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="modifiedByTd" [ngClass]="hide ? 'hide-column ' : 'show-column'">
									{{user.updatedBy}}
								</td>
								<td class="statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="user.status" (onChange)="changeStatus(user)"
											class="d-flex"></p-inputSwitch>
										<div class="label activeText" *ngIf="user.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!user.status">
											Inactive
										</div>
									</div>
								</td>
								<td class="actionTd p-frozen-column">
									<ul class="actionList">
										
										<li>
											<button (click)="editUser(user.id)" class="editBtn"><img
												src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deleteUser(user)" class="deleteBtn"><img
												src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
										<li>
											<button (click)="viewAdmin(user.id)" class="viewBtn"><img
												src="../../../assets/images/backend-image/common-images/view.svg"></button>
										</li>
									</ul> 
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="12">No Users found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>